// frontend/shared/src/qr.ts —— TD-836：二维码本地生成，不经第三方服务
import QRCode from 'qrcode';

export async function qrDataUrl(text: string, size = 180): Promise<string> {
  if (!text) throw new Error('二维码内容为空');
  if (!Number.isInteger(size) || size <= 0) throw new Error(`二维码尺寸非法：${size}`);
  return QRCode.toDataURL(text, { width: size, margin: 1, errorCorrectionLevel: 'M', color: { dark: '#0f1a17', light: '#ffffff' } });
}
